/* eslint-disable react/jsx-key */
/* eslint-disable camelcase */
import React from 'react'
import {
  Button,
  Flex,
  Heading,
  List,
  ListItem,
  Text,
  VStack,
  Card,
  CardBody,
  Divider,
  CardHeader,
  CardFooter,
  ButtonGroup,
  Stack,
  HStack,
  Box,
  keyframes,
} from '@chakra-ui/react'
import { render } from '@testing-library/react'

const Order = ({
  loading,
  order,
  theme = 'teal',
  locations,
  onOrderComplete,
  onOrderEdit,
  onOrderNotify,
  onOrderDrinksStart,
  menu,
}: {
  loading: boolean
  order: any
  theme: string
  locations: any
  onOrderComplete: any
  onOrderEdit: any
  onOrderNotify: any
  onOrderDrinksStart: any
  menu: any
}) => {
  const themes = {
    darkTeal: {
      bgColor: 'green.800',
      color: 'white',
      attentionColor: 'yellow.300',
    },
    darkBlue: {
      bgColor: 'blue.800',
      color: 'white',
      attentionColor: 'yellow.300',
    },
    darkOrange: {
      bgColor: 'blackAlpha.800',
      color: 'white',
      attentionColor: 'yellow.300',
    },
  }

  const glow = keyframes`
  0% {
    box-shadow: 0 0 5px rgba(255, 0, 0, 0.4),
     0 0 10px rgba(255, 0, 0, 0.4),
     0 0 20px rgba(255, 0, 0, 0.4),
     0 0 40px rgba(255, 0, 0, 0.4);
  }
  50% {
    box-shadow: 0 0 10px rgba(255, 0, 0, 0.8),
     0 0 20px rgba(255, 0, 0, 0.8),
     0 0 30px rgba(255, 0, 0, 0.8),
     0 0 50px rgba(255, 0, 0, 0.8);
  }
  100% {
    box-shadow: 0 0 5px rgba(255, 0, 0, 0.4),
     0 0 10px rgba(255, 0, 0, 0.4),
     0 0 20px rgba(255, 0, 0, 0.4),
     0 0 40px rgba(255, 0, 0, 0.4);
  }
`

  const renderChildren = (children: any, quantity: number, itemId: number) => {
    const childrenArray = Object.entries(children)
    const keyIndex = 0;
    const renderEmpty = quantity - childrenArray.length;
    if (renderEmpty > 0) {
      for (let i = 0; i < renderEmpty; i++) {
        childrenArray.push([`empty-${i}`, 'empty'])
      }
    }
    return childrenArray.map(([key, child]) => {
      if (child === 'empty') {
        return (
          <Flex
            bg='gray'
            px={2}
            borderRadius='none'
            key={`child-block-${key}`}
            direction='column'
            border={'1px solid #fff'}
            mb='3px !important'
            color='white'
            fontWeight={'bold'}
            w='full'
          >
            <Flex justifyContent='space-between' alignItems='center' px={2}>
              <Text>No additional options</Text>
              <Text></Text>
            </Flex>
          </Flex>
        )
      }

      if (!Array.isArray(child)) {
        return;
      }

      return (
        <Box key={`child-block-full-${key}`}>
          <Flex
            bg='gray'
            px={2}
            borderRadius='none'
            direction='column'
            border={'1px solid #fff'}
            mb='3px !important'
            color='white'
            fontWeight={'bold'}
            w='full'
          >
            {child.map((childItem: any) => {
              return (
                <Flex
                  key={`child-block-${childItem.id}-${itemId}-${order.id}-${keyIndex}`}
                  justifyContent='space-between'
                  alignItems='center'
                  px={2}
                >
                  <Text>{childItem.title}</Text>
                  <Text>x{childItem.quantity}</Text>
                </Flex>
              )
            })}
          </Flex>
        </Box>
      )
    });
  };

  const generateMenuList = (order: any) => {
    const drinksList: any = []
    const foodList: any = []

    const drinkIds = [2,3,29,30,32,33,39,46]
    order.items.forEach((item: any) => {
      if (drinkIds.includes(item.group_id)) {
        drinksList.push(item)
      } else {
        foodList.push(item)
      }
    })

    return (
      <>
        {foodList.length > 0 && (
          <HStack key={order.id + '-drink-divider'}>
            <Text
              bg='gray'
              color='white'
              w='full'
              textAlign='center'
              py={2}
              px={2}
              fontWeight='bold'
            >
              Food
            </Text>
          </HStack>
        )}

        {foodList.map((item: any, index: any) => {
          let renderChildrenItems = true;
           if (item.children.length === 0 || !item.children) {
             renderChildrenItems = false;
           }
           const childrenArray = item.children.length ? item.children : Object.entries(item.children)
           if (childrenArray.length === 0) {
             renderChildrenItems = false;
           }
          return (
            <HStack
              key={order.id + '-' + item.id}
              style={{ fontSize: '0.9rem', lineHeight: '1.2rem' }}
              py={1}
              px={4}
              bg={index % 2 === 0 ? '#eee' : ''}
              alignItems='start'
              w='full'
            >
              <Text>x{item.quantity}</Text>
              <VStack spacing={0} alignItems='left' w='full'>
                {renderChildrenItems ? (
                  <>
                    <Box>{item.title}</Box>
                    {renderChildren(item.children, item.quantity, item.id)}
                  </>
                ) : (
                  <Text>{item.title}</Text>
                )}
              </VStack>
            </HStack>
          )
        })}
        {order.comment && (
          <Text px={4} fontWeight='bold' fontSize='sm' my={2}>
            {order.comment}
          </Text>
        )}
        {drinksList.length > 0 && (
          <HStack key={order.id + '-food-divider'}>
            <Text
              bg='gray'
              color='white'
              w='full'
              textAlign='center'
              py={2}
              px={2}
              fontWeight='bold'
            >
              Drinks
              {order.status !== 'completed' && !order.drinks_started && (
                <Button
                  variant='solid'
                  colorScheme='green'
                  ml={2}
                  size='xs'
                  onClick={() => onOrderDrinksStart(order)}
                >
                  Start making
                </Button>
              )}
              {order.status !== 'completed' && order.drinks_started && (
                <Text
                  bg='gray'
                  color='lightgreen'
                  textAlign='center'
                  display='inline-block'
                  fontWeight='bold'
                  px={2}
                >
                  {order.drinks_started}
                </Text>
              )}
            </Text>
          </HStack>
        )}

        {drinksList.map((item: any, index: any) => {
          let renderChildrenItems = true;
           if (item.children.length === 0 || !item.children) {
             renderChildrenItems = false;
           }
           const childrenArray = item.children.length ? item.children : Object.entries(item.children)
           if (childrenArray.length === 0) {
             renderChildrenItems = false;
           }
          return (
            <HStack
              key={order.id + '-' + item.id}
              style={{ fontSize: '0.9rem', lineHeight: '1.2rem' }}
              py={1}
              px={4}
              bg={index % 2 === 0 ? '#eee' : ''}
              w='full'
            >
              <Text>x{item.quantity}</Text>
              <VStack spacing={0} alignItems='left' w='full'>
                {renderChildrenItems ? (
                  <>
                    <Box>{item.title}</Box>
                    {renderChildren(item.children, item.quantity, item.id)}
                  </>
                ) : (
                  <Text>{item.title}</Text>
                )}
              </VStack>
            </HStack>
          )
        })}
      </>
    )
  }

  const completeButton = (order: any) => {
    if (order.status === 'created') {
      return (
        <Button
          variant='solid'
          colorScheme='green'
          isDisabled={loading}
          onClick={() => onOrderComplete(order, 'preparing', parseFloat(getPaySum(order)) > 1.9)}
          borderRadius='no'
          w="80%"
          marginInlineStart="0 !important"
        >
          Start preparing
        </Button>
      )
    }

    if (order.status === 'preparing') {
      return (
        <Button
          variant='solid'
          colorScheme='gray'
          isDisabled={loading}
          onClick={() => onOrderComplete(order, 'ready')}
          borderRadius='no'
        >
          Preparing...
        </Button>
      )
    }

    if (order.status === 'ready') {
      return (
        <Button
          variant='solid'
          colorScheme='red'
          isDisabled={loading}
          onClick={() => onOrderComplete(order, 'completed')}
          borderRadius='no'
          w='80%'
          marginInlineStart='0 !important'
          sx={{
            animation: `${glow} 2s infinite alternate`,
          }}
        >
          READY
        </Button>
      )
    }

    if (order.status === 'created' || order.status === 'preparing' || order.status === 'ready') {
      return (
        <Button
          variant='solid'
          colorScheme={order.type === 'reservation' ? 'green' : ''}
          style={{ border: order.type != 'reservation' ? 'solid 1px #fff' : '' }}
          onClick={() => onOrderComplete(order, 'completed')}
          borderRadius='no'
          isDisabled={loading}
        >
          Complete
        </Button>
      )
    }
    if (order.status === 'completed') {
      return (
        <Button
          variant='solid'
          colorScheme='red'
          onClick={() => onOrderComplete(order, 'created')}
          borderRadius='no'
        >
          Reset
        </Button>
      )
    }
    return <></>
  }

  const includedSum = (order: any) => {
    let includedPrice = order.guests * 15
    if (includedPrice < 30) {
      includedPrice = 30
    }

    return includedPrice
  }

  const getPaySum = (order: any) => {
    const sumToPay = order.total_price - includedSum(order)
    return sumToPay > 0 ? sumToPay.toFixed(2) : '0'
  }

  const { bgColor, color, attentionColor } = themes[theme as keyof typeof themes]

  const renderDetail = (title: any, value: any) => (
    <Flex justifyContent='space-between' w='100%'>
      <Text fontSize='sm' fontWeight='bold'>
        {title}:
      </Text>
      <Text fontSize='sm'>{value}</Text>
    </Flex>
  )

  const renderHeading = (order: any) => {
    if (order.type === 'reservation') {
      return (
        <Heading size='lg' color={color}>
          {order.room}
        </Heading>
      )
    }

    return (
      <Heading size='md' color={color}>
        Table {order.orderTable}
      </Heading>
    )
  }

  const renderOrderName = (order: any) => {
    if (order.name) {
      return (
        <Text>
          Name: <b>{order.name}</b>
        </Text>
      )
    }

    if (order.orderName) {
      return (
        <Text>
          Name: <b>{order.orderName}</b>
        </Text>
      )
    }

    return;
  }


  const renderOrderPhone = (order: any) => {
    if (order.phone) {
      return (
        <Text>
          Phone: <b>{order.phone}</b>
        </Text>
      )
    }

    if (order.orderPhone) {
      return (
        <Text>
          Phone: <b>{order.orderPhone}</b>
        </Text>
      )
    }

    return;
  }

  const locationMessage = (locationString: string) => {
    return (
      locations.find((location: { location: string }) => location.location === locationString)
        ?.title || ''
    )
  }

  const renderGuests = (order: any) => {
    if (order.guests) {
      return (
        <Text>
          Guests:{' '}
          <b>
            {order.guests} ({includedSum(order)}€ included & {getPaySum(order)}€ to pay)
          </b>
        </Text>
      )
    }
    return (
      <Text>
        Guests: <b>{order.orderGuests ?? 0}</b>
      </Text>
    )
  }

  const renderTotal = (order: any) => {
    if (order.type === 'reservation') {
      return (
        <Text>
          Total:{' '}
          <b>
            {order.total_price}€ ({getPaySum(order)}€ to pay)
          </b>
        </Text>
      )
    }
    return (
      <Text>
        Total: <b>{order.total_price}€</b>
      </Text>
    )
  }

  const renderCreatedBy = (order: any) => {
    if (order.type === 'kitchen') {
      return (
        <Text>
          Added by: <b>{'Kitchen'}</b>
        </Text>
      )
    }

    if (order.type === 'waiter') {
      return (
        <Text>
          Added by: <b>{order.waiterName ?? 'invalid-waiter'}</b>
        </Text>
      )
    }
    return <></>
  }

  const canceledRender = (order: any) => {
    if (order.status === 'canceled' || order.status === 'declined') {
      return (
        <Stack
          position='absolute'
          fontSize={50}
          color='red.600'
          background='rgb(255 255 255 / 70%)'
          w='full'
          h='full'
          alignItems='center'
          justifyContent='center'
          textTransform='uppercase'
        >
          <Text>Canceled</Text>
        </Stack>
      )
    }
    return <></>
  }
  return (
    <Card
      key={order.id}
      borderRadius='lg'
      w='100%'
      boxShadow='base'
      alignItems='left'
      opacity={order.status === 'completed' ? 0.5 : 1}
      _hover={{ boxShadow: 'lg' }}
      className={order.notify === 1 ? 'glowing-box' : ''}
      onClick={() => onOrderNotify(order)}
    >
      {canceledRender(order)}

      <CardHeader color={color} bg={bgColor} py={3}>
        <VStack alignItems='middle' spacing={1}>
          <HStack justifyContent='space-between'>
            {renderHeading(order)}
            <VStack alignItems='end' spacing={0}>
              <Text lineHeight={1}>
                <b>{order.time}</b>
              </Text>
              <Text
                display='inline'
                fontWeight='bold'
                textTransform='uppercase'
                color={order.location === 'to the room' ? attentionColor : ''}
                as='span'
                mt={0}
                fontSize={14}
                lineHeight={1.5}
              >
                {locationMessage(order.location)}
              </Text>
            </VStack>
          </HStack>
          ;{renderOrderName(order)}
          {renderOrderPhone(order)}
          {renderGuests(order)}
          {renderCreatedBy(order)}
        </VStack>
      </CardHeader>
      <Divider />
      <ButtonGroup
        bg={bgColor}
        justifyContent={order.status === 'completed' ? 'flex-end' : 'space-between'}
        w='full'
      >
        {order.status !== 'completed' &&
          order.status !== 'canceled' &&
          order.status !== 'declined' && (
            <Button
              bg={color}
              color={bgColor}
              _hover={{ bg: bgColor, color: color }}
              onClick={() => onOrderEdit(order)}
              w="20%"
              borderRadius='no'
            >
              Edit
            </Button>
          )}

        {completeButton(order)}
      </ButtonGroup>
      {/* <Divider /> */}
      <CardBody px={0} pt={0} pb={2}>
        {order.items && order.items.length > 0 ? (
          <>
            {generateMenuList(order)}
          </>
        ) : (
          <VStack alignItems='left' spacing={4} h='full' justifyContent='center'>
            <Text textAlign='center' fontWeight='bold' fontSize='lg'>
              Table book only
            </Text>
            {order.comment && (
              <Text px={4} fontWeight='bold' fontSize='sm' mt={2} textAlign='center'>
                {order.comment}
              </Text>
            )}
          </VStack>
        )}
      </CardBody>
      {/* <Divider /> */}
      {/* <CardFooter bg={bgColor}> */}
      {/* <ButtonGroup
          justifyContent={order.status === 'completed' ? 'flex-end' : 'space-between'}
          w='full'
        >
          {order.status !== 'completed' &&
            order.status !== 'canceled' &&
            order.status !== 'declined' && (
              <Button
                bg={color}
                color={bgColor}
                _hover={{ bg: bgColor, color: color }}
                onClick={() => onOrderEdit(order)}
              >
                Edit
              </Button>
            )}

          {completeButton(order)}
        </ButtonGroup> */}
      {/* </CardFooter> */}
      {/* <HStack key={order.id + '-total'}>
            <Text
              bg='gray'
              color='white'
              w='full'
              textAlign='center'
              py={2}
              px={2}
              fontWeight='bold'
            >
              {renderTotal(order)}
            </Text>
          </HStack> */}
    </Card>
  )
}

export default Order
